import React from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";

const HomePage = () => {
  return (
    <div className="homepage">
      <Container fluid>
        <Row className="hero-section">
          <Col md={{ span: 6, offset: 3 }} className="text-center">
            <h1>Welcome to Fitness Tracker</h1>
            <p>
              Take control of your fitness journey with our intuitive tracking
              app.
            </p>
            <Button variant="primary" size="lg">
              Get Started
            </Button>
          </Col>
        </Row>
        <Row className="feature-section">
          <Col md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Track Your Progress</Card.Title>
                <Card.Text>
                  Monitor your fitness goals and stay motivated with detailed
                  tracking and analysis.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Personalized Plans</Card.Title>
                <Card.Text>
                  Create customized workout and nutrition plans tailored to your
                  needs and preferences.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Connect with Community</Card.Title>
                <Card.Text>
                  Join our vibrant community of fitness enthusiasts for support,
                  motivation, and shared experiences.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HomePage;
